import { getMYCAGlobalDomain } from '@americanexpress/rerouter';

const statementsAllowedRoutes = ['/statements'];

const statementsEnabledLocales = ['zh-TW', 'es-AR'];

const getIsEnabledLocales = (locale) => statementsEnabledLocales.includes(locale);

export const getMarketRedirectUrl = (state, locale) => {
  const domain = getMYCAGlobalDomain(state);
  const marketRedirects = {
    'es-AR': `${domain}/myca/intl/acctsumm/canlac/accountSummary.do?request_type=&Face=es_AR`,
    'zh-TW': `${domain}/myca/intl/acctsumm/japa/accountSummary.do?request_type=&Face=zh_TW`,
  };

  return marketRedirects[locale];
};

export const getStatementsRedirect = (locale, route, state) => {
  const isEnabledLocale = getIsEnabledLocales(locale);

  const shouldRedirect = isEnabledLocale
    && !statementsAllowedRoutes.some((url) => route.startsWith(url));

  if (shouldRedirect) {
    const redirectUrl = getMarketRedirectUrl(state, locale);
    return redirectUrl;
  }

  return '';
};

export default function statementsRedirect({ locale, route, state }) {
  const redirectUrl = getStatementsRedirect(locale, route, state);

  if (redirectUrl) {
    return {
      redirectUrl,
      isRoute: true,
    };
  }

  return {};
}
